//import * as React from 'react';

import { Slider as FabricSlider } from 'office-ui-fabric-react';
export const Slider = FabricSlider;